import FingerprintJS from '@fingerprintjs/fingerprintjs';
import Cookies from 'js-cookie';

// Identificación del dispositivo que se manda a la API al registrarse y al terminar de
// iniciar sesión. Con ella la API arma el historial de dispositivos de cada usuario y
// detecta varias cuentas usadas desde el mismo navegador.
//
// - X-Device-Id: fingerprint del navegador (FingerprintJS, licencia MIT).
// - X-Client-Ref: identificador aleatorio guardado en la cookie BROWSER_COOKIE de este
//   sitio. Es más estable que el fingerprint. La API también guarda su propia cookie con
//   el mismo valor donde el navegador lo permite (Safari y Brave la bloquean por estar
//   en otro dominio): por eso las peticiones que la usan van con credentials: 'include'.
//
// Nunca debe frenar al usuario: si el fingerprint falla o tarda más de MAX_WAIT_MS, la
// petición sale sin él.
const MAX_WAIT_MS = 2000;

// Nombre poco revelador a propósito.
const BROWSER_COOKIE = 'ah22';
const BROWSER_COOKIE_DAYS = 400; // máximo que acepta Chrome; se renueva en cada visita
const BROWSER_ID_FORMAT = /^[A-Za-z0-9_-]{16,64}$/;
// Solo para esta app (publicPath '/signature'), no para el resto del dominio.
const COOKIE_PATH = (process.env.BASE_URL || '/').replace(/\/$/, '') || '/';

let visitorIdPromise = null;

function loadVisitorId() {
  if (!visitorIdPromise) {
    try {
      // monitoring: false evita que la librería mande estadísticas de uso a sus servidores.
      visitorIdPromise = FingerprintJS.load({ monitoring: false })
        .then(agent => agent.get())
        .then(result => result.visitorId)
        .catch(() => null);
    } catch (e) {
      visitorIdPromise = Promise.resolve(null);
    }
  }
  return visitorIdPromise;
}

function newBrowserId() {
  const cryptoApi = window.crypto || window.msCrypto;
  if (!cryptoApi || !cryptoApi.getRandomValues) {
    return null;
  }
  const bytes = cryptoApi.getRandomValues(new Uint8Array(16));
  let hex = '';
  for (let i = 0; i < bytes.length; i++) {
    hex += ('0' + bytes[i].toString(16)).slice(-2);
  }
  return hex;
}

// Regresa el identificador del navegador; lo crea si no existe y lo vuelve a escribir
// para renovar su vigencia (Safari borra en 7 días las cookies creadas desde JS).
function browserId() {
  try {
    let id = Cookies.get(BROWSER_COOKIE);
    if (!id || !BROWSER_ID_FORMAT.test(id)) {
      id = newBrowserId();
    }
    if (id) {
      Cookies.set(BROWSER_COOKIE, id, {
        expires: BROWSER_COOKIE_DAYS,
        path: COOKIE_PATH,
        sameSite: 'lax',
        secure: window.location.protocol === 'https:'
      });
    }
    return id;
  } catch (e) {
    return null;
  }
}

export const deviceFingerprint = {
  // Empieza a calcular el fingerprint antes de necesitarlo (al abrir el login o el
  // registro) y renueva la cookie del navegador.
  preload() {
    browserId();
    loadVisitorId();
  },
  // Regresa los encabezados con X-Device-Id y X-Client-Ref agregados (los que se hayan
  // podido obtener).
  withDeviceHeader(headers = {}) {
    const timeout = new Promise(resolve => setTimeout(() => resolve(null), MAX_WAIT_MS));
    return Promise.race([loadVisitorId(), timeout])
      .then(visitorId => {
        const extra = {};
        if (visitorId) {
          extra['X-Device-Id'] = visitorId;
        }
        const ref = browserId();
        if (ref) {
          extra['X-Client-Ref'] = ref;
        }
        return Object.assign({}, headers, extra);
      });
  }
};
